<template>
  <div :class="scope.clsPrefix">
    <template v-if="isDemo">
      <div class="detail-header">
        <span class="room-tag">企业战情室</span>
        <div class="header-title">{{ detailData.title || "暂无报告" }}</div>
        <div class="warning-text">
          {{
            detailData.summary ||
            ""  }}
        </div>
      </div>
      <div class="highlight-box">
        <div class="highlight-desc">
          {{
            detailData.content ||
            ""  }}
        </div>
      </div>
      <div class="highlight-tags">
        <span
          v-for="(tag, index) in detailData.tagsArray"
          :key="index"
          class="highlight-tag"
          >{{ tag }}</span
        >
      </div>

      <!-- <div class="section">
        <div class="section-title">重点结论</div>
        <div class="conclusion-list">
          <div v-for="(item, index) in detailData.conclusions" :key="index" class="enter-conclusion-item">
            <div class="conclusion-dot"></div>
            <div class="conclusion-content">
              <div class="conclusion-title">{{ item.title }}</div>
              <div v-if="item.desc" class="conclusion-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="section">
        <div class="section-title">详细信息</div>
        <div class="enter-detail-grid">
          <div class="detail-card">
            <div class="detail-card-left">
              <div class="detail-label">报告类型</div>
              <div class="detail-desc">{{ detailData.reportTypeText }}</div>
            </div>
            <!-- <div class="detail-value">4.5万</div> -->
          </div>
          <div class="detail-card">
            <div class="detail-card-left">
              <div class="detail-label">数字人</div>
              <div class="detail-desc">{{ detailData.agentName }}</div>
            </div>
            <!-- <div class="detail-value">{{ detailData.impactText }}</div> -->
          </div>
          <div class="detail-card">
            <div class="detail-card-left">
              <div class="detail-label">创建时间</div>
              <div class="detail-desc">{{ detailData.createTime }}</div>
            </div>
            <!-- <div class="detail-value">{{ detailData.updateTime }}</div> -->
          </div>
        </div>
      </div>
    </template>
   <template v-else>
      <div class="detail-mini-header">
        <span class="room-tag">企业战情室</span>
        <div class="header-right">
          <!-- <button class="download-btn" type="button" @click="handleDownloadPdf">
            <i class="el-icon-download"></i> 下载
          </button> -->
          <div class="download-btn" @click="handleDownloadPdf">
            <img src="@/assets/imgs/detail/download_icon.png" alt="" width="16" height="16">
             下载
          </div>
          <div class="view-switch" :class="{ 'mode-web': viewMode === 'web', 'mode-doc': viewMode === 'doc' }">
            <div style="font-size: 12px" class="switch-tab tab-web" @click="viewMode = 'web'">网页</div>
            <div style="font-size: 12px" class="switch-tab tab-doc" @click="viewMode = 'doc'">文档</div>
          </div>
        </div>
      </div>
      <div ref="pdfContent">
        <div v-if="viewMode === 'doc'" class="markdown-body" v-html="renderedMarkdown"></div>
        <div v-else class="html-body" v-html="contentHtml"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { renderMarkdownText } from '@/utils/markdownRenderer'
import mermaid from 'mermaid'
// eslint-disable-next-line no-unused-vars
import { downloadPdf } from '@/utils/pdfDownload'
import { getJobReportDetailApi } from '@/api/agentAuth'
export default {
  name: 'EnterpriseDetail',
  components: {
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-enterprise-detail'
      },
      detailData: {},
      renderedMarkdown: '',
      viewMode: 'doc',
      contentHtml: ''
    }
  },
  computed: {
    isDemo() {
      return !this.id
    }
  },
  created() {
    this.fetchDetail()
  },
  watch: {
    id() {
      this.fetchDetail()
    }
  },
  methods: {
    async handleDownloadPdf() {
      const el = this.$refs.pdfContent
      if (!el) {
        this.$message.warning('暂无报告内容可下载')
        return
      }
      const title = (this.detailData && this.detailData.title) || '报告详情'
      await downloadPdf(el, title + '.pdf')
    },
    async fetchDetail() {
      // debugger
      if (!this.id) {
        this.detailData = {}
        return
      }
      try {
        const res = await getJobReportDetailApi(this.id)
        if (res && res.data) {
          this.detailData = this.transformData(res.data)
          this.renderedMarkdown = renderMarkdownText(res.data.content || '')
          this.contentHtml = res.data.contentHtml || ''
          this.$nextTick(() => this._initMermaid())
        } else {
          this.detailData = {}
          this.renderedMarkdown = ''
        }
      } catch (error) {
        console.error('获取企业战情室报告详情失败:', error)
        this.detailData = {}
        this.renderedMarkdown = ''
      }
    },
    transformData(data) {
      const tagsArray = data.tags
        ? data.tags.split(',').map((t) => t.trim())
        : []
      const conclusions = this.parseConclusions(data.content || data.summary)

      return {
        id: data.id,
        title: data.title,
        summary: data.summary,
        content: data.content,
        tags: data.tags,
        tagsArray: tagsArray,
        category: data.category,
        categoryText: this.getCategoryText(data.category),
        impactLevel: data.impactLevel,
        impactText: this.getImpactText(data.impactLevel),
        reportType: data.reportType,
        reportTypeText: this.getReportTypeText(data.reportType),
        agentName: data.agentName || 'CEO数字人',
        createTime: data.createTime || '',
        updateTime: data.updateTime || '',
        conclusions: conclusions
      }
    },
    parseConclusions(content) {
      if (!content) {
        return []
      }
      const lines = content.split(/[\n\r]+/).filter((line) => line.trim())
      return lines.map((line) => ({
        title: line.substring(0, 50),
        desc: line.length > 50 ? line : ''
      }))
    },
    getCategoryText(category) {
      const map = { internal: '内部报告', external: '外部报告' }
      return map[category] || '内部报告'
    },
    getImpactText(level) {
      if (level >= 5) return '负向影响'
      return '正向影响'
    },
    getReportTypeText(type) {
      const map = { market: '市场行情', policy: '政策法规', competitor: '竞品动态' }
      return map[type] || '市场行情'
    },
    _initMermaid() {
      const container = this.$refs.pdfContent
      if (!container) return
      const blocks = container.querySelectorAll('.mermaid-block__body')
      blocks.forEach(async (body) => {
        const block = body.closest('.mermaid-block')
        if (!block) return
        // 已被全局 MutationObserver 渲染过的跳过，避免重复渲染
        if (block.dataset.mermaidRendered === '1') return
        const encoded = block.getAttribute('data-mermaid')
        if (!encoded) return
        try {
          const code = decodeURIComponent(encoded)
          const { svg } = await mermaid.render('mm-' + Math.random().toString(36).slice(2), code)
          body.innerHTML = svg
          block.dataset.mermaidRendered = '1'
        } catch (e) {
          body.innerHTML = '<div class="mermaid-error">图表渲染失败</div>'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-enterprise-detail";

.#{$class-prefix} {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: #eee transparent;
  position: relative;
}
.#{$class-prefix}::-webkit-scrollbar {
  width: 4px;
}
.#{$class-prefix}::-webkit-scrollbar-track {
  background: transparent;
}
.#{$class-prefix}::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.detail-header {
  margin-bottom: 32px;
}
.room-tag {
  width: 84px;
  height: 24px;
  background-image: linear-gradient(270deg, #4a5ff3 0%, #67b7f9 100%);
  box-shadow: inset 0 0 8px 0 #ffffff80;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  margin-bottom: 12px;
}
.header-title {
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  font-family: PingFangSC-Medium;
  margin-bottom: 8px;
}
.warning-text {
  font-family: PingFangSC-Medium;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
}
.highlight-box {
  height: 72px;
  background: #ffffff;
  border: 1px solid #4a5ff3;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 12px 23px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #4a5ff3;
  line-height: 24px;
  margin-bottom: 12px;
}
.highlight-desc {
  // font-size: 14px;
  // color: #333;
  // line-height: 1.6;
  // font-family: PingFangSC-Regular;
  // margin-bottom: 12px;
}
.highlight-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 32px;
}
.highlight-tag {
  height: 22px;
  border: 1px solid #dddddd;
  border-radius: 2px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  padding: 3px 8px;
}
.section {
  margin-bottom: 32px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  font-family: PingFangSC-Medium;
}
.core-indicators {
  height: 64px;
  display: flex;
  gap: 10px;
}
.indicator-card {
  flex: 1;
  padding: 0 24px;
  background: #edf1fb;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  &.positive {
    .indicator-value {
      color: #4caf50;
    }
  }
}
.enter-indicator-label {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 12px;
  color: #595959;
}
.indicator-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  font-family: PingFangSC-Medium;
}
.value-unit {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}
.conclusion-list {
  border: 1px solid #edf1fb;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}
.enter-conclusion-item {
  display: flex;
  gap: 16px;
  // padding: 14px;
  // background: #FAFBFC;
  // border-radius: 8px;
}
.conclusion-dot {
  width: 8px;
  height: 8px;
  background: #4a5ff3;
  border-radius: 50%;
  margin-top: 6px;
  flex-shrink: 0;
}
.conclusion-content {
  flex: 1;
}
.conclusion-title {
  font-size: 14px;
  font-weight: 600;
  color: #4a5ff3;
  margin-bottom: 6px;
  font-family: PingFangSC-Medium;
}
.conclusion-desc {
  font-size: 14px;
  color: #333;
  font-family: PingFangSC-Medium;
}
.enter-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.detail-card {
  padding: 16px 24px;
  height: 70px;
  border: 1px solid #edf1fb;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.detail-label {
  font-size: 14px;
  color: #4a5ff3;
  font-weight: 600;
  margin-bottom: 4px;
  font-family: PingFangSC-Medium;
}
.detail-desc {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #aaaaaa;
}
.detail-value {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  font-family: PingFangSC-Bold;
}
.header-right {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  float: right;
  position: absolute;
  top: 24px;
  right: 24px;
}

.view-switch {
  display: inline-flex;
  height: 24px;
  position: relative;
  border-radius: 4px;
  overflow: visible;
}

.switch-tab {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s ease;
  position: relative;
}

.switch-tab.tab-web {
  background: #eef4ff;
  color: #666;
  clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
  border-radius: 4px 0 0 4px;
}

.switch-tab.tab-doc {
  background: #eef4ff;
  color: #666;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0 100%);
  border-radius: 0 4px 4px 0;
  margin-left: -6px;
}

.view-switch.mode-web .tab-web {
  background: #4a5ff3;
  color: #fff;
  z-index: 1;
}

.view-switch.mode-web .tab-doc {
  background: #f5f7fa;
  color: #999;
}

.view-switch.mode-doc .tab-doc {
  background: #4a5ff3;
  color: #fff;
  z-index: 1;
}

.view-switch.mode-doc .tab-web {
  background: #f5f7fa;
  color: #999;
}

.html-body {
  line-height: 1.8;
  color: #333;
}

.detail-mini-header {
  margin-bottom: 24px;
}

.download-btn {
  // float: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  // padding: 6px 16px;
  border: none;
  border-radius: 4px;
  // background: #4a5ff3;
  color: #4A5FF3;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  width: 72px;
  height: 24px;
  border: 1px solid #4A5FF3;
  border-radius: 4px;
}

// .download-btn:hover {
//   background: #3a4fe3;
// }

.markdown-body.html-body {
  line-height: 1.8;
  color: #333;
  font-size: 14px;
}
.html-body {
  width: 100%;
}
.markdown-body ::v-deep h1,
.markdown-body ::v-deep h2,
.markdown-body ::v-deep h3 {
  margin-top: 24px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #1a1a1a;
}
.markdown-body ::v-deep p {
  margin-bottom: 16px;
  line-height: 1.8;
}
.markdown-body ::v-deep ul,
.markdown-body ::v-deep ol {
  margin-bottom: 16px;
  padding-left: 24px;
}
.markdown-body ::v-deep table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
}
.markdown-body ::v-deep th,
.markdown-body ::v-deep td {
  border: 1px solid #e8ecf0;
  padding: 8px 12px;
  text-align: left;
}
.markdown-body ::v-deep th {
  background: #f5f7ff;
  font-weight: 600;
}
.markdown-body ::v-deep strong {
  font-weight: 600;
}
</style>

<style lang="scss">
@import '@/assets/styles/report-markdown.scss';
</style>
